/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Mushy_Loris_ClimbInputs */

const fr_brave_mushy_loris_climb = /** @type {(inputs: Brave_Mushy_Loris_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrouvez ici toutes les informations relatives à la sécurité de votre compte.`)
};

/**

* @param {Brave_Mushy_Loris_ClimbInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const brave_mushy_loris_climb = /** @type {((inputs?: Brave_Mushy_Loris_ClimbInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Mushy_Loris_ClimbInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_brave_mushy_loris_climb(inputs)
});